module.exports = __webpack_public_path__ + "img/data-structure.454d5610.png";